import React, { useState, useEffect } from "react";
import firebase from "firebase/app";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  DialogActions,
  DialogContentText,
  Button,
  CircularProgress,
} from "@material-ui/core";
import { setErrorDetails } from "../../../api/userSlice";
import { useDispatch } from "react-redux";

export default function ChangePasswordDialog(props) {
  const { handleClose, open } = props;

  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");
  const [isUpdating, setIsUpdating] = useState(false);
  const dispatch = useDispatch();

  const passwordsDontMatch =
    newPassword && confirmNewPassword && newPassword !== confirmNewPassword;

  const handleUpdatePassword = async () => {
    if (passwordsDontMatch) return;

    setIsUpdating(true);

    try {
      await firebase
        .auth()
        .signInWithEmailAndPassword(
          firebase.auth().currentUser.email,
          oldPassword
        );

      await firebase.auth().currentUser.updatePassword(newPassword);

      dispatch(
        setErrorDetails({
          message: null,
        })
      );

      handleClose();
    } catch (error) {
      dispatch(
        setErrorDetails({
          message: error.message,
        })
      );
    } finally {
      setIsUpdating(false);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="form-dialog-title"
    >
      <DialogTitle id="form-dialog-title">Update password</DialogTitle>

      <DialogContent>
        <DialogContentText>
          Please fill in these fields to change your password.
        </DialogContentText>

        <TextField
          autoFocus
          type="password"
          margin="dense"
          label="Old password"
          fullWidth
          onChange={(e) => setOldPassword(e.target.value)}
        />

        <TextField
          type="password"
          margin="dense"
          label="New password"
          fullWidth
          onChange={(e) => setNewPassword(e.target.value)}
        />

        <TextField
          type="password"
          margin="dense"
          label="Confirm new password"
          fullWidth
          error={passwordsDontMatch}
          helperText={passwordsDontMatch ? "Passwords do not match" : ""}
          onChange={(e) => setConfirmNewPassword(e.target.value)}
        />
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose} color="white">
          Cancel
        </Button>

        <Button
          color="primary"
          onClick={handleUpdatePassword}
          disabled={isUpdating || passwordsDontMatch || newPassword.length < 3}
        >
          {isUpdating ? <CircularProgress size={10} /> : "Update"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
